import moment from "moment";
import React, { useEffect, useState } from "react";
import { GeneralObject } from "../../../../../definitions/general";
import Flex from "../../../../structure/Flex";
import DateTimePicker from "../DateTimePicker";

const TIMESPAN: GeneralObject = {
  month: "This Month",
  week: "This Week",
  day: "Today",
  select: "Select",
};

type DateRangeSelectorModes = "day" | "week" | "month" | "select";

interface DateRangeSelectorProps {
  startDate: moment.Moment | undefined;
  setStartDate: React.Dispatch<moment.Moment | undefined>;
  endDate: moment.Moment | undefined;
  setEndDate: React.Dispatch<moment.Moment | undefined>;
  startOnMode?: DateRangeSelectorModes;
  hideTime?: true;
}

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  startOnMode = "week",
  hideTime,
}) => {
  const [mode, setMode] = useState(startOnMode);
  useEffect(() => {
    if (mode !== "select") {
      setStartDate(moment().startOf(mode));
      setEndDate(moment().startOf("day").add(1, "day"));
    }
  }, [mode, setEndDate, setStartDate]);

  return (
    <Flex col className="w-full">
      <Flex className="w-full flex-wrap">
        {Object.keys(TIMESPAN).map((k) => (
          <span
            key={k}
            onClick={() => setMode(k as DateRangeSelectorModes)}
            className={`p-2 text-xs font-medium m-1 text-white ${
              k === mode ? "bg-text text-white" : "bg-accent text-text"
            } rounded-lg`}
          >
            {TIMESPAN[k]}
          </span>
        ))}
      </Flex>
      {mode === "select" && (
        <Flex className="justify-between transition ease-in-out duration-100 flex-wrap my-2">
          <Flex col className="mx-2 flex-grow">
            <span className="my-1 font-medium text-subtitle text-xs uppercase">
              Start Date
            </span>
            <DateTimePicker
              value={startDate}
              setValue={setStartDate}
              name="report-start-date"
              hideTime={hideTime}
            />
          </Flex>
          <Flex col className="mx-2 flex-grow">
            <span className="my-1 font-medium text-subtitle text-xs uppercase">
              End Date
            </span>
            <DateTimePicker
              value={endDate}
              setValue={setEndDate}
              name="report-end-date"
              hideTime={hideTime}
            />
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};

export default DateRangeSelector;
